<template style="height:100%">
  <div class="main-content">
    <!--顶部-->
    <head-banner></head-banner>
    <!--中央区域-->
    <div class="wrapper_full mt20 bg_line">
      <div class="wrapper_width">
        <div class="detail_left">
          <div class="kuang_bigimg"><img :src="selectBookData.virtualRoute + selectBookData.resourceCover"/></div>
          <div class="detail_word">
            <h3>{{selectBookData.resourceName}}</h3>
            <div>
              <ul>
                <li><span class="volume-attrib">数&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;量&nbsp;：</span><span>{{selectBookData.resourceResume}}</span></li>
                <li><span class="volume-attrib">编&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;著&nbsp;：</span><span>{{selectBookData.authorName}}</span></li>
                <li><span class="volume-attrib">价&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格&nbsp;：</span><span>{{selectBookData.resourcePrice}}</span></li>
                <li><span class="volume-attrib">发刊地址&nbsp;：</span><span>{{selectBookData.resourceAddress}}</span></li>
                <li><span class="volume-attrib">报刊时间&nbsp;：</span><span>{{selectBookData.resourceTime}} - {{selectBookData.resourceEndTime}}</span></li>
                <!--li><span class="volume-attrib">点&nbsp;&nbsp;击&nbsp;&nbsp;量&nbsp;：</span><span>{{selectBookData.useCount}}</span></li-->
              </ul>
            </div>
            <div v-if="yearStatList.length>1">
              <div><h4>年份列表</h4></div>
              <ul v-for="oneyear in yearStatList" :key="oneyear.statLabel">
                <li><a @click="getDetailDataByYear(oneyear.statLabel)"><span class="volume-attrib">{{oneyear.statLabel}}</span><span>({{oneyear.statCount}})</span></a></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="detail_right">
          <div class="book_querykeyp-bar">
            <el-row type="flex" justify="center">
              <span class="book_querykey-word-label">关键词：</span>
              <el-input class="book_querykey-input" v-model="editSearchKeyWord" placeholder="请输入关键字" @change="changeEditSearchKeyWord"></el-input>
              <el-button class="book_querykey-button" icon="el-icon-search" @click="clickKeyWordQuery">检索</el-button>
            </el-row>
          </div>
          <component :is="detailCompName" :dataList="paramData" :ref="detailCompName" @clickReturnParent="clickReturnParent"></component>
        </div>
      </div>
    </div>
    <!--底部-->
    <foot-template></foot-template>
  </div>
</template>


<script>
import headBanner from "../template/head"
import footTemplate from "../template/foot"
import detailList from './detaillist'
import searchList from "../column/searchList";
import indexList from "../column/indexList";


export default {
  name: "pageIndex",
  components: {
    headBanner,
    footTemplate,
    detailList
  },

  data(){
    return{
      headHeight: 300,
      bannerHeight: 290,
      tableLoading: false,
      editSearchKeyWord:"",
      detailCompName:"detailList",
      yearStatList:[],
      paramData: {
        title: "gary column title.",
        categroyGuid: "",
        queryYear: "",
        resourceName: ""
      },
    }
  },
  created() {
    this.initData();
  },
  mounted() {
    this.detailCompName = detailList;
  },
  methods: {
    initData:function() {
      this.selectBookData = this.$route.query;
      this.paramData.categroyGuid = this.selectBookData.guid;
      this.paramData.extStr = null;
      this.paramData.resourceName = this.selectBookData.resourceName;
    },
    getDetailDataByYear(selectYear){
      this.detailCompName = detailList;
      this.$nextTick(() => {
        this.$refs[this.detailCompName].getDetailDataByYear(selectYear)
      })
    },
    changeEditSearchKeyWord() {
      this.paramData.queryWord = this.editSearchKeyWord;
    },
    clickKeyWordQuery() {
      if (this.editSearchKeyWord!=null && this.editSearchKeyWord.trim()!=''){
        var searchKeyword = this.editSearchKeyWord;
        this.detailCompName = indexList;
        this.$nextTick(() => {
          this.$refs[this.detailCompName].indexQueryDataByKeyWordAndResourcelGuid(this.paramData.categroyGuid,searchKeyword)
        })
      }else{
        Message.info("请输入要检索的关键字。");
      }
    },
    clickReturnParent(){
      alert(a);
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import url('../../styles/common.css');
  @import url('../../styles/main.css');

</style>



// WEBPACK FOOTER //
// src/view/readpage/index.vue